import React, { useEffect, useRef, useState } from "react";
import { douyin, sort_bottom, sort_top } from "@/assets/Inspiration-center";
import LabelSwitching from "@/components/business/LabelSwitching";
import IndustryCard from "../IndustryCard";
import useData from "../../useData";
import "./index.less";
import SortBox from "../SortBox";
import { Input, Spin } from "@arco-design/web-react";
import { IconLeft, IconRight, IconSearch } from "@arco-design/web-react/icon";
import GridContainer from "@/components/UI/GridContainer";
function MySubscription() {
  const {
    handleReaderCreator,
    accountList,
    creatorsList,
    handleClick,
    clickedIndexes,
    handleVideoListSort,
    creatorVideoSearch,
    setCreatorVideoSearch,
    creatorsLoading,
    netCursor,
    setNetCursor,
    setCreatorsList,
    setCreatorsListEctype,
    handleDeletesScriptReader,
    isCreators,
    isAtLeft,
    handleMouseDown,
    handleMouseUpOrLeave,
    isAtRight,
    contentWrapperRef,
    handleMouseMove,
    handleMouseDownDrag,
    timeDifference,
  } = useData();

  const [isAll, setIsAll] = useState<boolean>(true);
  const observableElementRef = useRef(null);
  useEffect(() => {
    handleReaderCreator();
  }, []);

  useEffect(() => {
    const element = observableElementRef.current;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !creatorsLoading && netCursor && isCreators) {
        creatorVideoSearch.cursor = netCursor;
        setCreatorVideoSearch({
          ...creatorVideoSearch,
        });
      }
    });

    if (element) {
      observer.observe(element);
    }
    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, [creatorsLoading, observableElementRef.current, isCreators]);
  useEffect(() => {
    if (!clickedIndexes.length) {
      setIsAll(true);
    }
  }, [clickedIndexes]);

  return (
    <div className="subscription-root">
      <Spin loading={creatorsLoading}>
        <div className="account-box">
          <p>账号</p>
          <div
            className={`account-all-box subscription-select  ${isAll ? "subscription-active" : ""}`}
            onClick={() => {
              setIsAll(true);
              handleClick(null);
            }}>
            <div className="account-all">全部</div>
            <span>全部订阅</span>
          </div>
          <div
            className={`scroll-left ${isAtLeft ? "hidden" : ""}`}
            onMouseDown={() => handleMouseDown(-1)}
            onMouseUp={handleMouseUpOrLeave}
            onMouseLeave={handleMouseUpOrLeave}>
            <IconLeft fontSize={20} />
          </div>
          <div
            ref={contentWrapperRef}
            className="account-wrapper"
            onMouseMove={handleMouseMove}
            onMouseDown={handleMouseDownDrag}
            onMouseUp={handleMouseUpOrLeave}
            onMouseLeave={handleMouseUpOrLeave}>
            <div className="subscription-list">
              {accountList.map((item, index) => (
                <div key={index} className="subscription-box">
                  <div
                    className="delete-avatar"
                    onClick={async (e) => {
                      if (timeDifference > 300) {
                        e.preventDefault();
                        return;
                      }
                      setIsAll(true);
                      handleDeletesScriptReader(item.id);
                    }}>
                    <div></div>
                  </div>
                  <div
                    className={`subscription-select ${
                      clickedIndexes.includes(item.id) &&
                      !isAll &&
                      "subscription-active"
                    }`}
                    onClick={(e) => {
                      if (timeDifference > 300) {
                        e.preventDefault();
                        return;
                      }
                      setIsAll(false);
                      handleClick(item.id);
                    }}>
                    <div>
                      <img src={item.avatar_url} alt="" className="avatar" />
                      <img src={douyin} alt="" className="platform" />
                    </div>
                    <p>{item.nickname}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div
            className={`scroll-right ${isAtRight ? "hidden" : ""}`}
            onMouseDown={() => handleMouseDown(1)}
            onMouseUp={handleMouseUpOrLeave}
            onMouseLeave={handleMouseUpOrLeave}>
            <IconRight fontSize={20} />
          </div>
        </div>
      </Spin>

      <div className="industry-tool">
        <SortBox renderProps={handleVideoListSort} />
        <div className="industry-search">
          <Input
            style={{ height: 40 }}
            prefix={<IconSearch />}
            onBlur={(e) => {
              //
            }}
            onPressEnter={(e) => {
              creatorVideoSearch.keyword = e.target.value;
              creatorVideoSearch.cursor = 0;
              setCreatorsList([]);
              setCreatorsListEctype([]);
              setNetCursor(0);
              setCreatorVideoSearch({ ...creatorVideoSearch });
            }}
            placeholder="输入关键词"
          />
        </div>
      </div>
      <Spin loading={creatorsLoading}>
        <div className="industry-card-box">
          <GridContainer dataLength={creatorsList.length} boxGap={33}>
            {creatorsList.map((v, i) => (
              <div
                key={i}
                ref={(ref) => {
                  if (creatorsList.length - 1 == i) {
                    observableElementRef.current = ref;
                  }
                }}>
                <GridContainer.Item>
                  <IndustryCard item={v} />
                </GridContainer.Item>
              </div>
            ))}
          </GridContainer>
        </div>
      </Spin>
    </div>
  );
}

export default MySubscription;
